import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M31.44 2.01006C45.53 2.89006 51.15 12.91 52.8 21.06C55.65 35.14 50.5901 55.19 50.5901 55.19C50.5901 55.19 52.02 43.3 50.04 29.87C47.68 13.87 37.7101 11.59 37.7101 11.59C37.7101 11.59 36.07 11.04 34.19 13.57C31 17.86 28.6901 17.86 27.5901 17.86C26.4901 17.86 23.96 17.86 20.76 13.57C18.88 11.04 17.24 11.59 17.24 11.59C17.24 11.59 7.27001 13.87 4.91001 29.87C2.93001 43.3 4.36002 55.19 4.36002 55.19C4.36002 55.19 -0.589977 38.79 1.61002 23.37C2.51002 17.1 6.56006 10.1601 11.5201 7.41008C15.3701 5.27008 18.35 5.42998 18.35 5.42998C18.35 5.42998 22.76 1.46006 31.44 2.01006Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M25.8301 17.31C25.8301 17.31 27.2601 10.59 33.3201 7.06999C37.9201 4.38999 44.1101 5.09005 47.1901 9.38005"
        stroke={outline}
        strokeMiterlimit="10"
      />
      <path
        d="M28.1401 17.97C28.1401 17.97 31.8801 3.43998 45.4201 8.05998"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M48.4002 13.0101C46.9902 12.4701 45.6302 12.0101 44.2802 11.6501C42.9302 11.3101 41.6002 11.1201 40.3102 11.1701C39.0102 11.2001 37.7802 11.57 36.6102 12.21C36.0002 12.49 35.4702 12.93 34.8902 13.34C34.3102 13.76 33.8402 14.3001 33.2002 14.7601C33.4602 14.0601 33.7402 13.33 34.1502 12.68L34.8502 11.74C35.0702 11.4 35.4202 11.2001 35.7102 10.9201C36.9202 9.88009 38.5602 9.19009 40.2002 9.17009C41.8402 9.10009 43.4202 9.50999 44.8102 10.19C46.2102 10.88 47.4602 11.8001 48.4002 13.0101Z"
        fill={outline}
      />
      <path
        d="M22.96 16.1C22.96 16.1 25.1599 4.53995 32.4299 2.44995"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.4199 14.01C21.4199 14.01 22.1899 4.97995 27.8099 2.44995"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path d="M19.33 12.13C19.33 12.13 18.23 6.74004 21.86 3.54004" stroke={outline} strokeMiterlimit="10" />
      <path d="M15.5901 12.35C15.5901 12.35 10.6401 9.49001 6.89014 12.13" stroke={outline} strokeMiterlimit="10" />
      <path
        d="M17.24 11.14C17.24 11.14 13.61 7.39998 10.52 8.49998"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M10.6301 15.77C10.6301 15.77 6.45011 14.7799 3.36011 19.6199"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M44.3201 16.4299C44.3201 16.4299 51.26 16.54 52.91 24.25"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
